/* eslint-disable react/display-name */
import { theme } from '@salecycle/ui-component-library';
import { TFunction } from 'i18next';
import moment from 'moment';
import { Column } from 'react-table';
import { EditButton } from './EditButton';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRoleTableColumns = (t: TFunction, push: any): Column[] => {
  return [
    {
      Header: t('userManagement.roles.view.table.roleHeader'),
      accessor: 'name',
      width: 200,
    },
    {
      Header: t('userManagement.roles.view.table.createdHeader'),
      accessor: 'createdAt',
      width: 200,
      Cell: (props): string => {
        const mo = moment(props.value).format('YYYY-MM-DD hh:mm A');
        return mo.toString();
      },
    },
    {
      Header: t('userManagement.roles.view.table.descriptionHeader'),
      accessor: 'description',
      getProps: () => {
        return {
          style: {
            color: theme.vars.newColor.darkGS2,
          },
        };
      },
    },
    {
      width: 90,
      Cell: props => {
        return <EditButton onClick={() => push(`/user-management/roles/${props.original.id}`)} />;
      },
    },
  ];
};
